import constants from '../../../../../../appConstants';
import { MultiSelectFilter, DateTimeFilter } from '@dataGrid/components/columnFilters';
import { DriverStatusIcon } from '../../../RouteExecution/Drivers/Grid/cellRenderer';
import { getDriverStatus } from '../../../RouteExecution/utils/DriverStatus';
import TimeRenderer from './TimeFieldRenderer';
import { DotRenderer } from '@dataGrid/components/cellRenderer';
import CustomerNameCell from '../../../../../common/CustomerMergeIndicator/CustomerNameCell';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }
  static getConfiguration(config) {
    return GridConfig.getDefaultConfiguration(config);
  }

  static driverNameRenderer(params) {
    const {
      data: { driverName, driverNumber, isRouteCompleted },
      api
    } = params;
    const driverInfo = (
      <span>{`${driverName} ${driverNumber ? '(' + driverNumber + ')' : ''}`}</span>
    );
    if (isRouteCompleted) {
      return driverInfo;
    }
    return (
      <div className="linkText" onClick={() => api.runCommand('showDriver', params.data)}>
        {driverInfo}
      </div>
    );
  }

  static customerNameRenderer({ data }) {
    const { stopNumber, displayCustomerName, customerName } = data;
    return (
      <div className='displayName'>
        {stopNumber && <div className="stopNumber">{stopNumber}</div>}
        <div>
          <CustomerNameCell displayCustomerName={displayCustomerName} customerName={customerName} />
        </div>
      </div>
    );
  }

  static statusValueGetter({ data }) {
    if (data.isCompleted) {
      return constants.DELIVERY_STATUS.COMPLETED;
    }
    return constants.DELIVERY_STATUS.PENDING;
  }

  static getArrivalTime({ data }) {
    return data.isCompleted ? data.actualArrivalTime : data.plannedArrivalTime;
  }

  static getDepartureTime({ data }) {
    return data.isCompleted ? data.actualDepartureTime : data.plannedDepartureTime;
  }

  static showDriverStatus(params) {
    if (params.isRouteCompleted) {
      return null;
    }
    return Boolean(params.data.driverInfo) ? (
      <DriverStatusIcon data={params.data.driverInfo} context={params.data.terminalOffset} />
    ) : null;
  }
  static driverStatusValue(params) {
    if (params.isRouteCompleted) {
      return '';
    }
    return Boolean(params.data.driverInfo)
      ? getDriverStatus({
          data: params.data.driverInfo,
          context: params.data.terminalOffset
        })
      : '';
  }

  static getDefaultConfiguration(_config) {
    return {
      title: constants.gridNames.PriorityShipmentsGrid,
      keyColumn: '',
      rowSelection: 'multiple',
      rowDeselection: true,
      suppressRowTransform: true,
      defaultColDef: {
        lockPinned: true,
        editable: false
      },
      columns: [
        {
          headerName: '',
          minWidth: constants.columnWidth.VIOLATION_DOT,
          maxWidth: constants.columnWidth.VIOLATION_DOT,
          field: 'violation',
          pinned: 'left',
          lockPosition: true,
          cellClass: ['gridCell-centerAlign', 'gridCell-dot'],
          filter: false,
          cellRenderer: DotRenderer,
          isInvisibleInShowHide: true,
          gridTitle: constants.gridNames.PriorityShipmentsGrid
        },
        {
          headerName: 'Pro#',
          field: 'proId',
          headerTooltip: 'Pro Number',
          minWidth: constants.columnWidth.W_130,
          maxWidth: constants.columnWidth.W_140,
          cellClass: 'gridCell-leftAlign',
          pinned: 'left',
          lockPosition: true,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING
          }
        },
        {
          headerName: 'Status',
          headerTooltip: 'Status',
          maxWidth: constants.columnWidth.W_110,
          minWidth: constants.columnWidth.W_110,
          cellClass: 'gridCell-leftAlign',
          valueGetter: GridConfig.statusValueGetter,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Arrival Time',
          valueGetter: GridConfig.getArrivalTime,
          cellRenderer: TimeRenderer,
          headerTooltip: 'Arrival Time',
          minWidth: constants.columnWidth.W_130,
          maxWidth: constants.columnWidth.W_130,
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true
          }
        },
        {
          headerName: 'Departure Time',
          valueGetter: GridConfig.getDepartureTime,
          cellRenderer: TimeRenderer,
          headerTooltip: 'Departure Time',
          minWidth: constants.columnWidth.W_140,
          maxWidth: constants.columnWidth.W_140,
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.TIME,
            isTimeInterval: true
          }
        },
        {
          headerName: 'Driver Status',
          cellRenderer: GridConfig.showDriverStatus,
          valueGetter: GridConfig.driverStatusValue,
          headerTooltip: 'Driver Status',
          minWidth: constants.columnWidth.W_200,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'Driver Status'
        },

        {
          headerName: 'Customer',
          field: 'displayCustomerName',
          headerTooltip: 'Customer Name',
          minWidth: constants.columnWidth.W_150,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          cellRenderer: GridConfig.customerNameRenderer
        },
        {
          headerName: 'Address',
          field: 'customerAddress',
          headerTooltip: 'Address',
          width: constants.columnWidth.W_150,
          minWidth: constants.columnWidth.W_100,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'customerAddress'
        },
        {
          headerName: 'City',
          field: 'city',
          headerTooltip: 'City',
          width: constants.columnWidth.CITY,
          minWidth: constants.columnWidth.W_100,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          tooltipField: 'city'
        },
        {
          headerName: 'Driver',
          field: 'driverName',
          headerTooltip: 'Driver Name',
          minWidth: constants.columnWidth.W_240,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          cellRenderer: GridConfig.driverNameRenderer,
          tooltipField: 'driverName'
        }
      ]
    };
  }
}
